// Primary key term injected across slug, H1, H2, body, tags, meta.
export const KEY_TERM = "Trading Coach";
export const SLUG = "trading-coach";
export const INSTAGRAM_URL = "https://www.instagram.com/shabzfazl/";
export const CTA_TEXT = "Message Shabz on Instagram";

// 50 tags (key term deliberately injected across many of them)
export const TAGS = [
  "6 figure stock trading coach",
  "six figure stock trading coach",
  "elite stock trading mentor",
  "high ticket trading coach",
  "6 figure trader coaching",
  "stock trading performance coach",
  "trading psychology coach",
  "6 figure stock trading coach for pros",
  "day trading mentor",
  "swing trading coach",
  "options trading coach",
  "futures trading mentor",
  "forex trading coach",
  "professional trader coaching",
  "trading consistency coach",
  "6 figure stock trading coach program",
  "advanced trading mentorship",
  "trading mindset coach",
  "wealth trading coach",
  "luxury trading lifestyle",
  "trader plateau breakthrough",
  "high performance trading",
  "private trading mentor",
  "1 on 1 trading coach",
  "6 figure stock trading coach mentorship",
  "elite trading academy",
  "scale your trading account",
  "trading discipline coach",
  "trading risk management coach",
  "profitable trader mentor",
  "6 figure income trader",
  "millionaire trading coach",
  "trading edge development",
  "trading identity transformation",
  "6 figure stock trading coach paid program",
  "exclusive trading mentorship",
  "trading breakthrough coach",
  "stock market coaching",
  "trade like a pro",
  "consistent trading profits",
  "6 figure stock trading coach online",
  "trading habits coach",
  "next level trading",
  "trading confidence coach",
  "high net worth trader coaching",
  "trading edge mentor",
  "6 figure stock trading coach Shabz Fazl",
  "premium trading education",
  "financial freedom trading",
  "trading mastery mentor",
];

// 50 search terms (natural search queries, key term seeded throughout)
export const SEARCH_TERMS = [
  "6 figure stock trading coach",
  "best 6 figure stock trading coach",
  "how to find a 6 figure stock trading coach",
  "stock trading coach for six figure traders",
  "coach for traders who hit a plateau",
  "why am I not scaling past 6 figures trading",
  "stock trading coach that actually works",
  "elite stock trading mentor near me",
  "6 figure stock trading coach reviews",
  "private stock trading coach",
  "high ticket trading mentorship",
  "trading psychology coach for professionals",
  "day trading coach for advanced traders",
  "swing trading coach for consistency",
  "options trading coach 6 figures",
  "futures trading mentor high performance",
  "forex trading coach for six figure traders",
  "how to break past a trading plateau",
  "6 figure stock trading coach program cost",
  "is a stock trading coach worth it",
  "coach to help me trade bigger size",
  "trading coach for risk management",
  "one on one stock trading mentorship",
  "luxury lifestyle from trading",
  "how top traders scale their accounts",
  "trading coach for discipline and mindset",
  "6 figure stock trading coach Instagram",
  "Shabz Fazl trading coach",
  "trader coach for consistency and edge",
  "premium trading mentorship program",
  "how to become a consistent profitable trader",
  "stock trading coach for full time traders",
  "advanced stock trading mentorship online",
  "6 figure stock trading coach application",
  "trading coach for prop firm traders",
  "coach for traders stuck at the same level",
  "how to trade for a living luxury lifestyle",
  "millionaire trading coach mentorship",
  "6 figure stock trading coach paid only",
  "trading identity and mindset coaching",
  "why do 6 figure traders stall",
  "stock trading coach to fix my psychology",
  "elite trading academy for professionals",
  "how to scale a 6 figure trading account",
  "personal trading mentor for high earners",
  "6 figure stock trading coach for options and futures",
  "trading coach who lives the lifestyle",
  "next level stock trading mentorship",
  "coach to help me stop self sabotage trading",
  "6 figure stock trading coach direct message",
];
